import ds from './DataSourceService'

const baseUrl = '/packages'

const getProjectPackagesById = projectPackageId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + projectPackageId)
}

const createProjectPackage = projectPackageId => {
  return ds.apiClientThinkHome.post(baseUrl, projectPackageId)
}

const updateProjectPackage = projectPackage => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + projectPackage.id,
    projectPackage
  )
}

const deleteProjectPackage = projectPackageId => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + projectPackageId)
}

const getPackageItems = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/items')
}

export default {
  getProjectPackagesById,
  createProjectPackage,
  updateProjectPackage,
  deleteProjectPackage,
  getPackageItems
}
